import React, { Fragment } from "react";
import { Box } from "@chakra-ui/react";
import { colours } from "@shared/ui.design-system";

type Props = {
  totalSlides: number;
  activeIndex: number;
  onBulletClick: (index: number) => void;
};

export const CustomPagination: React.FC<Props> = ({
  totalSlides,
  activeIndex,
  onBulletClick
}) => {
  return (
    <Box
      id="swiper-pagination-custom"
      w="full"
      textAlign="center"
      position="absolute"
      top="auto"
      bottom="20px"
    >
      {Array.from({ length: totalSlides }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={`swiper-pagination-custom-${index}`}>
          <Box
            className={`swiper-pagination-bullet ${
              index === activeIndex ? "swiper-pagination-bullet-active" : ""
            }`}
            style={{
              margin: "0 5px !important",
              width: "10px",
              height: "10px",
              backgroundColor:
                index === activeIndex
                  ? colours.accent.strong
                  : colours.secondary.strong,
              opacity: 1
            }}
            onClick={() => onBulletClick(index)}
          />
        </Fragment>
      ))}
    </Box>
  );
};
